import React from 'react';

import {
  Card as SpectrumCard,
  CardBody,
  CardCoverPhoto
} from '@react/react-spectrum/Card';

const Card = ({ data }) => {
  const imgSrc =
    data.img ||
    `https://salesvelocity.experiencecloud.adobe.com/exc-content/static/media/2048x1280.c6d3911e.jpg`;
  const subtitle = data.subtitle || 'Marketo';
  const title = data.url;

  return (
    <SpectrumCard allowsSelection={false}>
      <CardCoverPhoto src={getSolutionImage(data.imsOrg.name)} />
      <CardBody title={title} subtitle={subtitle} />
    </SpectrumCard>
  );
};

function getSolutionImage(name) {
  let number = (name.length % 4) + 1;

  return `https://demo-system-dashboard.s3.eu-north-1.amazonaws.com/images/marketo-${number}.jpg`;
}
export default Card;
